import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import {
  OdooProductsService,
  Product,
} from 'src/app/services/odoo-products.service';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { LabelsService, LabelType } from 'src/app/services/labels.service';
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerTypeHint,
} from '@capacitor/barcode-scanner';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ToolbarModule,
  ],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class HomeComponent implements OnInit {
  odooProductsService = inject(OdooProductsService);
  labelsService = inject(LabelsService);
  products: Product[] = [];
  selectedProducts!: Product[];

  loading = false;

  async ngOnInit() {
    this.loading = true;
    const res = await this.odooProductsService.getProducts();
    this.products = res.data.products;
    this.loading = false;
  }

  async generateLabels(type: LabelType) {
    this.loading = true;
    console.log('Generating labels...');
    await this.labelsService.generateLabels(type, this.selectedProducts);
    this.loading = false;
  }

  async read(product: Product) {
    const result = await CapacitorBarcodeScanner.scanBarcode({
      hint: CapacitorBarcodeScannerTypeHint.ALL,
      scanText: 'Leer código de barras',
    });
    console.log('Scanned barcode:', result.ScanResult);
    console.log('product:', product);
    await this.odooProductsService.updateProduct(result.ScanResult, product)
  }
}
